import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useGetChartAccountDetails } from "../../../../hooks/api/queries";

const ChartAccountDetails = () => {
  const { account_id } = useParams();
  const navigate = useNavigate();
  const {
    data: chartAccountDetails,
    isFetching: isFetchingChartAccountDetails,
    refetch: refetchChartAccountDetails,
  } = useGetChartAccountDetails(account_id, {
    enabled: !!account_id,
  });
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Chart Account Details"
      description="View chart account details and transactions"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          exit={{ opacity: 0 }}
        >
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <primaryComponents.Button
              classNames="btn btn--outline"
              onClick={() => navigate(-1)}
            >
              <FontAwesomeIcon
                icon="angle-left"
                className="mr-3"
                style={{ fontSize: "18px" }}
              />
              <span>Back</span>
            </primaryComponents.Button>
            <h4 className="font-weight-semibold mb-0">
              {isFetchingChartAccountDetails
                ? "Loading..."
                : `${chartAccountDetails?.account_code} - ${chartAccountDetails?.account_name}`}
            </h4>
          </div>

          <secondaryComponents.LoaderHelper
            classNames="mt-5"
            isLoading={isFetchingChartAccountDetails}
          >
            <secondaryComponents.ChartAccountDetails
              chartAccountDetails={chartAccountDetails}
              refetchChartAccountDetails={refetchChartAccountDetails}
            />
          </secondaryComponents.LoaderHelper>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default ChartAccountDetails;
